import { showAlert } from "../components/common/ErrorAlert/ErrorAlert";
import api from "./api";
import { baseURL } from "./api";

// Vehicle Types

export async function vehicleTyp(id = null, params = {}) {
  try {
    if (id) {
      const response = await api.get(`vehicle/vehicleType/?id=${id}`);
      return response;
    } else {
      const response = await api.get("vehicle/vehicle-type/", { params });
      return response;
    }
  } catch (error) {
    throw error;
  }
}

export async function vehicleTypActive() {
  try {
    const response = await api.get("vehicle/vehicle-type/active/");
    return response.data.data;
  } catch (error) {
    console.log("Error fetching Vehicle types: ", error);
  }
}

export async function AddVehicleType(formData) {
  try {
    const response = await api.post("vehicle/vehicle-type/", formData);
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

export async function EditVehicleType(formData) {
  try {
    const response = await api.put(
      `vehicle/vehicle-type/?id=${formData.id}`,
      formData,
    );
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}
export async function DeleteVehicleType(id) {
  try {
    const response = await api.delete(`vehicle/vehicle-type/delete/?id=${Array.isArray(id) ? id.join(',') : id}`);
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message);
  }
}

export async function ArchiveVehicleType(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("vehicle/vehicle-type/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`vehicle/vehicle-type/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    throw error;
  }
}

//Vehicle - Add

export async function Vehiclelist(id = null, params = {}) {
  try {
    if (id) {
      const response = await api.get(`vehicle/?id=${id}`);
      return response.data;
    } else {
      const response = await api.get("vehicle/", { params });
      return response.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function vehicleActive() {
  try {
    const response = await api.get("vehicle/active/");
    return response.data.data;
  } catch (error) {
    console.log(error);
  }
}

export async function ArchiveVehicleList(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("vehicle/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`vehicle/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    throw error;
  }
}

// export async function AddVehicle(formData) {
//   try{
//     const response = await api.post('vehicle/vehicle-info/',formData);
//     console.log("response",response)
//     return response
//   }catch(error){
//     console.log("Error adding Vehicle")
//   }
// }

export async function AddInsurance(formData) {
  try {
    const response = await api.post("vehicle/insurance/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

export async function AddPuc(formData) {
  try {
    const response = await api.post("vehicle/pucc/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

export async function AddTax(formData) {
  try {
    const response = await api.post("vehicle/tax/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

export async function AddDocument(formData) {
  try {
    const response = await api.post("vehicle/document/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.error("Error adding document:", error.message);
    throw error;
  }
}

export async function addVehicleWithDetails(formData) {
  try {
    const response = await api.post("vehicle/create/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

// export async function getVehicle(id) {
//   try {
//     const response = await api.get(`vehicle/vehicle-info/?id=${id}`);
//     return response.data.data;
//   } catch (error) {
//     console.log("Error fetching vehicle:", error);
//     throw error;
//   }
// }

// export async function getAllVehicle(params = {}) {
//   try {
//     const response = await api.get('vehicle/vehicle-info/', { params });
//     return response.data.data;
//   } catch (error) {
//     console.log("Error fetching all vehicles:", error);
//     throw error;
//   }
// }

export async function getInsurance(id) {
  try {
    const response = await api.get(`vehicle/insurance/?id=${id}`);
    return response;
  } catch (error) {
    console.log("Error fetching Insurance : ", error);
  }
}

export async function getTax(id) {
  try {
    const response = await api.get(`vehicle/tax/?id=${id}`);
    return response;
  } catch (error) {
    console.log("Error fetching Tax : ", error);
  }
}

export async function getPuc(id) {
  try {
    const response = await api.get(`vehicle/pucc/?id=${id}`);
    return response;
  } catch (error) {
    console.log("Error fetching PUC : ", error);
  }
}

export async function getDocument(vehicle_id) {
  try {
    const response = await api.get(
      `vehicle/document/?vehicle_id=${vehicle_id}`,
    );
    return response;
  } catch (error) {
    console.log("Error fetching Documents : ", error);
  }
}

export async function vehicleEdit(formData, id) {
  try {
    const response = await api.put(`vehicle/update/?id=${id}`, formData);
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

export async function vehicleDelete(uuid) {
  try {
    const response = await api.delete(`vehicle/delete/?id=${Array.isArray(uuid) ? uuid.join(',') : uuid}`);
    return response;
  } catch (error) {
    throw error;
  }
}

export const PucEdit = async (formData) => {
  try {
    return await api.put(`vehicle/pucc/?id=${formData.id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  } catch (error) {
    showAlert(error.response?.data?.message || "Something went wrong");
  }
};

export const TaxEdit = async (formData) => {
  try {
    return await api.put(`vehicle/tax/?id=${formData.id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  } catch (error) {
    showAlert(error.response?.data?.message || "Something went wrong");
  }
};

export const InsuranceEdit = async (formData) => {
  try {
    return await api.put(`vehicle/insurance/?id=${formData.id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  } catch (error) {
    showAlert(error.response?.data?.message || "Something went wrong");
  }
};

export async function VehicleDocumentDelete(item) {
  try {
    const response = await api.delete(`vehicle/document/?id=${item}`);
    return response;
  } catch (error) {
    console.log("Error Deleting Document", error);
  }
}

export async function DocumentDownload(file_path) {
  console.log(file_path);
  try {
    const response = await api.get(`vehicle/download-file/${file_path}`, {
      responseType: "blob",
    });
    const blob = response.data;
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", file_path.split("/").pop());
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    showAlert(error);
    throw error;
  }
}

export async function DocumentView(file_path) {
  try {
    const fileURL = `${baseURL}vehicle/view-file/${file_path}`;
    window.open(fileURL, "_blank");
  } catch (error) {
    console.log("Error fetching document", error);
    throw error;
  }
}

export async function InsuranceHistory(vehicle_id, params = {}) {
  try {
    const response = await api.get(
      `vehicle/insurance/?vehicle_id=${vehicle_id}`,
      {
        params,
      },
    );
    return response;
  } catch (error) {
    console.log("Error Fetching Insurance");
    throw error;
  }
}

export async function TaxHistory(vehicle_id, params = {}) {
  try {
    const response = await api.get(`vehicle/tax/?vehicle_id=${vehicle_id}`, {
      params,
    });
    return response;
  } catch (error) {
    console.log("Error Fetching History");
    throw error;
  }
}

export async function PucHistory(vehilce_id, params = {}) {
  try {
    const response = await api.get(`vehicle/pucc/?vehicle_id=${vehilce_id}`, {
      params,
    });
    return response;
  } catch (error) {
    console.log("Error Fetching History");
    throw error;
  }
}

export async function ChangeProfilePic(formData) {
  try {
    const data = new FormData();
    data.append("profile_pic", formData.profile_pic);

    const response = await api.put(`vehicle/?id=${formData.id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response;
  } catch (error) {
    console.log("Error updating profile picture:", error);
  }
}

//maintenance

// For listing
export async function getMaintenanceList(params = {}) {
  try {
    const response = await api.get("vehicle/maintenance/", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
}

// For single maintenance by ID
export async function getMaintenance(id) {
  try {
    const response = await api.get(`vehicle/maintenance/?id=${id}`);
    return response.data.data;
  } catch (error) {
    console.log(error);
  }
}

export async function ArchiveMaintenance(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("vehicle/maintenance/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`vehicle/maintenance/archive?id=${id}`);
    }
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function duplicateMaintenance(id) {
  const response = await api.post(`vehicle/maintenance/duplicate/?id=${id}`);
  return response.data;
}

export async function MaintenanceAdd(formData) {
  try {
    const response = await api.post("vehicle/maintenance/create/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.error("Error adding Maintenance:", error);
    throw error; // rethrow so caller (handleAdd) can catch it
  }
}

export async function MaintenanceEdit(id, formData) {
  try {
    const response = await api.patch(
      `vehicle/maintenance/update/?maintenance_id=${id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function MaintenanceDelete(id) {
  try {
    const response = await api.delete(`vehicle/maintenance/mobile/delete/?id=${Array.isArray(id) ? id.join(',') : id}`);
    return response;
  } catch (error) {
    throw error;
  }
}

// export async function MaintenanceExpenseAdd(formData) {
//   try{
//     const response = await api.post('vehicle/maintenance/expense/',formData);
//     return response
//   }catch(error){
//     console.log("Error adding Maintenance Expense")
//   }
// }

// export async function MaintenanceExpenseDelete(item) {
//   try{
//     const response = await api.delete(`vehicle/maintenance/expense/?id=${item}`);
//     return response
//   }catch(error){
//     console.log(error)
//   }
// }

// export async function getMaintenanceExpense(maintenance_id){
//   try{
//       const response =await api.get(`vehicle/maintenance/expense/?maintenance_id=${maintenance_id}`);
//       return response
//   }catch (error) {
//       console.log(error);
//     }

// }

// export async function ExpenseDocAdd(formData) {
//   try {
//       const response = await api.post('vehicle/maintenance-document/', formData, {
//           headers: {
//               "Content-Type": "multipart/form-data",
//           },
//       });
//       console.log("response",response.data)
//       return response;
//   } catch (error) {
//       console.error("Error adding document:", error.message);
//       throw error;
//   }
// }

// export async function getExpenseDoc(maintenance_id){
//   try{
//       const response =await api.get(`vehicle/maintenance-document/?maintenance_id=${maintenance_id}`);
//       return response.data.data
//   }catch (error) {
//       console.log(error);
//     }

// }

// export async function MaintenanceDocumentDelete(item) {
//   try{
//     const response = await api.delete(`vehicle/maintenance-document/?id=${item}`);
//     return response
//   }catch(error){
//     console.log(error)
//   }
// }

// vehicle_assign

export async function getVehicleAssign(id = null, params = {}) {
  try {
    if (id) {
      const response = await api.get(`vehicle/vehicle-assign/?id=${id}`);
      return response;
    } else {
      const response = await api.get("vehicle/vehicle-assign", { params });
      return response;
    }
  } catch (error) {
    console.log("Error fetching Vehicle Assign: ", error);
  }
}

export async function VehicleAssignEdit(formData) {
  try {
    const response = await api.put(
      `vehicle/vehicle-assign/?id=${formData.id}`,
      formData,
    );
    return response;
  } catch (error) {
    console.log("Error assigning Vehicle");
  }
}

export async function ArchiveVehicleAssign(id) {
  try {
    const response = await api.get(`vehicle/vehicle-assign/archive/?id=${id}`);
    return response;
  } catch (error) {
    console.log("Error Archiving Vehicle : ", error);
  }
}

export async function getDriver(id = null, params = {}) {
  try {
    if (id) {
      const response = await api.get(`vehicle/driver/?id=${id}`);
      return response.data;
    } else {
      const response = await api.get("vehicle/driver", { params });
      return response.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function getActiveDriver() {
  try {
    const response = await api.get("vehicle/driver/active/");
    return response.data.data;
  } catch (error) {
    console.log("Error fetching Driver: ", error);
  }
}

export async function ArchiveDriver(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("vehicle/driver/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`vehicle/driver/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    throw error
  }
}

export async function DriverAdd(formData) {
  try {
    const response = await api.post("vehicle/driver/", formData);
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

export async function CreateDriver(formData) {
  try {
    const response = await api.post("vehicle/driver/create/", formData);
    return response;
  } catch (error) {
    throw error;
  }
}

// export async function DriverDocAdd(formData) {
//   try {
//       const response = await api.post('vehicle/driver/document/', formData, {
//           headers: {
//               "Content-Type": "multipart/form-data",
//           },
//       });
//       return response;
//   } catch (error) {
//       console.error("Error adding document:", error.message);
//       throw error;
//   }
// }

// export async function DriverDocumentDelete(item) {
//   try{
//     const response = await api.delete(`vehicle/driver/document/?id=${item}`);
//     return response
//   }catch(error){
//     console.log("Error Deleting Document",error)
//   }
// }

// export async function getDriverDoc(driver_id) {
//   try{
//     const response = await api.get(`vehicle/driver/document/?driver_id=${driver_id}`);
//     return response.data.data
//   }catch(error){
//     console.log("Error getting Document",error)
//   }
// }

export async function DriverEdit(driverId, formData) {
  try {
    const response = await api.put(
      `vehicle/driver/update/?id=${driverId}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );

    return response;
  } catch (error) {
    throw error
  }
}

export async function DriverDelete(uuid) {
  try {
    let response;
    if (Array.isArray(uuid)) {
      response = await api.delete(`vehicle/driver/delete/?id=${uuid.join(',')}`);
    } else {
      response = await api.delete(`vehicle/driver/${uuid}/delete/`);
    }
    return response;
  } catch (error) {
    throw error;
  }
}

//penalties

// export async function getPenalties(id = null, params = {}) {
//   try {
//     const response = id
//       ? await api.get(`vehicle/penalty/?id=${id}`)
//       : await api.get("vehicle/penalty", { params });

//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// }
export async function getPenalties(id = null, params = {}) {
  try {
    const url = id ? `vehicle/penalty/?id=${id}` : "vehicle/penalty/grouped/";
    const config = id ? {} : { params };

    const response = await api.get(url, config);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function PenaltyAdd(formData) {
  try {
    const response = await api.post("vehicle/penalty/create/", formData);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function PenaltyEdit(Id, formData) {
  try {
    const response = await api.put(
      `vehicle/penalty/update/?id=${Id}`,
      formData,
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function PenaltyDelete(uuid) {
  try {
    let response;
    if (Array.isArray(uuid)) {
      response = await api.delete(`vehicle/penalty/delete/?id=${uuid.join(',')}`);
    } else {
      response = await api.delete(`vehicle/penalty/${uuid}/delete/`);
    }
    return response;
  } catch (error) {
    throw error;
  }
}

export async function ArchivePenalties(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("vehicle/penalty/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`vehicle/penalty/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    throw error
  }
}

// currency symbol

export async function getCurrencySymbol() {
  try {
    const response = await api.get("organization/currency-symbol/");
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function MaintenancePaymentAdd(formData) {
  try {
    return await api.post("payments/maintenance/create/", formData);
  } catch (error) {
    throw error
  }
}

export async function CreateMaintenanceDraft(formData) {
  try {
    const response = await api.post(
      "vehicle/maintenance/create-draft/",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

export async function CreateMaintenanceSubmit(formData) {
  try {
    const response = await api.post(
      "vehicle/maintenance/create-submit/",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response;
  } catch (error) {
    console.log("errr",error.response?.data?.message || "Something went wrong")
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

export const submitMaintenance = (uuid) =>
  api.post(`vehicle/maintenance/${uuid}/submit/`);

export const approveMaintenance = (uuid, journal) => {
  return api.post(
    `vehicle/maintenance/${uuid}/approve/`,
    journal ? { journal } : {},
  );
};

export const rejectMaintenance = (uuid, reason) =>
  api.post(`vehicle/maintenance/${uuid}/reject/`, {
    reject_reason: reason,
  });

// export const refundMaintenance = (uuid) =>
//   api.post(`vehicle/maintenance/${uuid}/refund/`);
